/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// These are assigned onto window deliberately: the modules below, and inline scripts in the
// ERB views, reference them as globals at call time.
window.Popup = require('../javascripts/popup.js');
window.Util = require('../javascripts/util.js');
window.DatetimeRange = require('../javascripts/datetime-range.js');
window.Resize = require('../javascripts/resize.js');
window.ThresholdStatus = require('../javascripts/threshold-status.js');
window.Form = require('../javascripts/form.js');

require('../javascripts/set-moment-locale.js');

window.D3Util = require('../javascripts/d3-util.js');
window.Nvd3Util = require('../javascripts/nvd3-util.js');
